import { MiniChips } from "@website/ui/mini-chips";
import { RadioGroup } from "@website/ui/radio-group";
import { RadioTypes } from "@website/widget/filter/filter.types";
import styles from "@website/widget/filter/index.module.scss";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";

interface RadioProperties extends RadioTypes {
  name: string;
}

export const RadioFilter = ({
  name,
  title,
  description,
  type,
  defaultValue,
  items,
  isNew
}: RadioProperties) => {
  const { control, setValue } = useFormContext();
  const router = useRouter();

  const parsedInitialValues = useMemo(
    () => String(router.query[name] ?? defaultValue),
    [defaultValue, name, router.query]
  );

  useEffect(() => {
    setValue(name, { type, value: parsedInitialValues });
  }, [name, parsedInitialValues, setValue, type]);

  return (
    <div className={styles["radio-filter-container"]}>
      <div className="grid grid-cols-3 items-center justify-start gap-2 whitespace-nowrap">
        <div className={styles["filter-header"]} id="has-availability">
          {title}
        </div>
        {description && (
          <span className={styles["has-availability"]}>{description}</span>
        )}
        {isNew && (
          <MiniChips color="primary" text="جدید" variant="round-contained" />
        )}
      </div>

      <Controller
        control={control}
        name={`${name}.value`}
        render={({ field }) => (
          <RadioGroup
            className="w-full flex-col !items-start"
            color="secondary"
            itemClassName={`${
              process.env["NEXT_PUBLIC_BASE_PATHNAME"]?.includes("رزرو-هتل") ||
              process.env["NEXT_PUBLIC_BASE_PATHNAME"]?.includes("villa")
                ? "!text-body-2"
                : "text-subtitle-2"
            }`}
            items={items}
            radioClassName="!w-full !flex !justify-between"
            {...field}
          />
        )}
      />
    </div>
  );
};
